<template>
  <div class="map-tooltip" v-if="isVisible" :style="{ top: tooltipPosition.y + 'px', left: tooltipPosition.x + 'px' }">{{ content }}</div>
</template>

<script>
export default {
  name: 'MapTooltip',
  data() {
    return {
      content: '',
      isVisible: false,
      timerId: null,
      tooltipPosition: { x: 0, y: 0 },
    };
  },
  methods: {
    show(content, delay, position) {
      clearTimeout(this.timerId);
      this.content = content;
      this.tooltipPosition = position;
      this.isVisible = false;
      this.timerId = setTimeout(() => {
        this.isVisible = true;
      }, delay);
    },
    hide() {
      clearTimeout(this.timerId);
      this.isVisible = false;
    },
  },
};
</script>



<style scoped>
.map-tooltip {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: white;
  padding: 5px;
  border: 1px solid black;
}
</style>
